export type ReportPeriod = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';

export function parseReportPeriod(value: string | null): ReportPeriod {
  return value === 'DAY' ||
    value === 'WEEK' ||
    value === 'YEAR'
    ? value
    : 'MONTH';
}

export function shiftReportPeriodAnchor(anchor: string, period: ReportPeriod, direction: -1 | 1): string {
  const date = new Date(`${anchor}T12:00:00Z`);
  if (period === 'DAY' || period === 'WEEK') date.setUTCDate(date.getUTCDate() + direction * (period === 'WEEK' ? 7 : 1));
  else if (period === 'MONTH') { date.setUTCDate(1); date.setUTCMonth(date.getUTCMonth() + direction); }
  else { date.setUTCMonth(0, 1); date.setUTCFullYear(date.getUTCFullYear() + direction); }
  return date.toISOString().slice(0, 10);
}

export function formatReportPeriodTitle(
  anchor: string,
  period: ReportPeriod,
): string {
  const date = new Date(`${anchor}T12:00:00`);
  if (period === 'DAY') {
    return new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }
  if (period === 'WEEK') {
    const start = new Date(date);
    const weekday = (start.getDay() + 6) % 7;
    start.setDate(start.getDate() - weekday);
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    return `${start.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short',
    })} — ${end.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })}`;
  }
  if (period === 'YEAR') return String(date.getFullYear());
  return new Intl.DateTimeFormat('ru-RU', {
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function reportBucketLabel(
  from: string,
  period: ReportPeriod,
  timezone?: string,
): string {
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: timezone,
    ...(period === 'DAY'
      ? { hour: '2-digit' as const }
      : period === 'YEAR'
        ? { month: 'short' as const }
        : period === 'WEEK'
          ? { weekday: 'short' as const }
          : { day: 'numeric' as const }),
  }).format(new Date(from));
}

export function reportChartTitle(period: ReportPeriod): string {
  if (period === 'DAY') return 'Расходы за день';
  if (period === 'WEEK') return 'Расходы за неделю';
  if (period === 'YEAR') return 'Расходы за год';
  return 'Расходы за месяц';
}

export function reportComparison(current: number, previous: number): string {
  if (previous === 0) {
    return current === 0 ? 'Без изменений' : 'Нет данных для сравнения';
  }
  const percent = Math.round(((current - previous) / previous) * 100);
  if (percent === 0) return 'Без изменений';
  return `${percent > 0 ? '+' : '−'}${Math.abs(percent)}% к прошлому периоду`;
}

export function reportComparisonTone(
  current: number,
  previous: number,
  higherIsBetter: boolean,
): '' | 'positive' | 'negative' {
  if (previous === 0 || current === previous) return '';
  const improved = higherIsBetter ? current > previous : current < previous;
  return improved ? 'positive' : 'negative';
}
